/**
 * This file will export observables that could be reused among map feature components.
 */

import { distinctUntilChanged, filter, fromEvent, map } from 'rxjs';
import { store$ } from '@redux/store';
import { selectZoomLevel } from './selectors';

const mapContainer = document.querySelector('#nhs_map');

export const mapContainerDoubleClicked$ = fromEvent(mapContainer, 'dblclick');
export const mapContainerClicked$ = fromEvent(mapContainer, 'click');
export const mapClicked$ = fromEvent(mapContainer, 'mapClick');
export const mapDragStart$ = fromEvent(mapContainer, 'mapDragStart');
export const mapDragEnd$ = fromEvent(mapContainer, 'mapDragEnd');
export const mapMouseOver$ = fromEvent(mapContainer, 'mouseover');

/**
 * onZoomChanged$ will emit a stream every time map zoom level changes.
 */
export const onZoomChanged$ = store$.pipe(map(selectZoomLevel), distinctUntilChanged(), filter(Boolean));
